import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import "./diagram-info-banner.scss";

/**
 * The Diagram tab's top notice. Step fields and user interactions bind to a Business
 * Object parameter's fields, so until the process has one, none of that works — this
 * bar says so and jumps to the Parameters tab. It renders only on the Diagram tab and
 * only while no Business Object parameter exists (the host owns that condition).
 */

export interface IDiagramInfoBannerProps {
  onGoToParameters: () => void;
}

const DiagramInfoBanner = ({ onGoToParameters }: IDiagramInfoBannerProps): JSX.Element => (
  <div className="kuika-diagram-banner" role="status">
    <span className="kuika-diagram-banner__message">
      <KuikaSvg name="info-circle" width={16} height={16} color="var(--blue-5)" />
      <span className="kuika-diagram-banner__text">
        <strong>No parameters defined yet.</strong> Fields and interactions won&apos;t work until you add Business
        Object parameters.
      </span>
    </span>
    <button type="button" className="kuika-diagram-banner__cta" onClick={onGoToParameters}>
      GO TO PARAMETERS
      <KuikaSvg name="arrow-right" type="arrows" width={14} height={14} color="var(--blue-5)" />
    </button>
  </div>
);

export default DiagramInfoBanner;
